/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Injectable } from '@angular/core';

import {
  ApiService,
  AuthenticatedApiService,
  AuthenticationService,
} from 'rest-client';
import { Observable } from 'rxjs';

import { SessionStatsRequest } from '../../models/session-stats.model';

@Injectable()
export class SessionEventsService {
  constructor(
    private unauthenticatedApi: ApiService,
    private authenticatedApi: AuthenticatedApiService,
    private authService: AuthenticationService
  ) {}

  sendSessionStats(data: SessionStatsRequest): Observable<unknown> {
    if (this.authService.isTokenValid() && this.authService.isClient()) {
      try {
        return this.authenticatedApi.post(
          `reservation/booking_session_event`,
          data
        ) as Observable<unknown>;
      } catch (error) {
        return null;
      }
    } else {
      try {
        return this.unauthenticatedApi.post(
          `reservation/booking_session_event`,
          data
        ) as Observable<unknown>;
      } catch (error) {
        return null;
      }
    }
  }
}
